<!-- 产品中心 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_innovate.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="产品中心" en="PRODUCT CENTER"></sub-title>
      </div>
      <div class="box">
        <div class="w1200">
          <div class="text">
            <p>
              担负行业发展趋势分析研究与贯彻、传统咨询服务转型升级、公司咨询新产品研发、客户需求研究、产品价值研究、产品质量品质管控、信息数字管理运用的重要责任，打造极具竞争力和可持续性的咨询产品和服务品质，构建值得信赖的志扬工程咨询服务品牌，有力推动客户项目建设目标的达成，保障客户核心利益和良好体验。
            </p>
            <p>传统咨询产品提质升级，构建公司咨询产品和服务竞争力的</p>
          </div>
          <img
            src="http://api.zyzxgc.cn/file/static/productCenter_img.png"
            class="right"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/productCenter_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;
  }
  .box {
    margin-top: 60px;
    margin-bottom: 120px;
    padding: 70px 0;
    position: relative;

    &::before {
      content: "";
      display: block;
      width: 52%;
      height: 480px;
      background: #5e5d5d;
      position: absolute;
      left: 0;
      top: 0;
    }
    &::after {
      content: "";
      display: block;
      width: 65%;
      height: 250px;
      background: $theme;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .w1200 {
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 2;

      .text {
        width: 370px;
        margin-top: 30px;
        font-size: 15px;
        color: #ffffff;
        line-height: 30px;
        text-indent: 2em;
      }
      .right {
        width: 800px;
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .box {
      margin: 30px 0;
      padding: 20px 0;

      &::before {
        width: 100%;
      }
      &::after {
        display: none;
      }
      .w1200 {
        display: block;

        .text {
          width: 100%;
          padding: 0 10px;
          margin-top: 0;
          box-sizing: border-box;
        }
        .right {
          width: 100%;
          height: auto;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
